import { Reveal, Overline } from "./Reveal";

const CASES = [
  {
    img: "https://lh3.googleusercontent.com/d/1VRaVbvwSE31abb0dMo7cns7YTU6Bm3_b=w700",
    name: "Marcus",
    meta: "6 months in",
    tag: "Home & Kitchen",
    stat: "$444.6K",
    label: "Year to date · +1080%",
    quote: "Woke up to a $70k day. Still doesn't feel real.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1gQDwAG_5TO453dikXzJNn99ljtHgxmB-=w700",
    name: "Danielle",
    meta: "6 months in",
    tag: "Pet Supplies",
    stat: "$371.1K",
    label: "Year to date · +889%",
    quote: "I check the app once a day. That's my whole job now.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1VtFXfROiQdSg72BRzjHgBpP6Osp5hIA8=w700",
    name: "Tyler",
    meta: "14 months in",
    tag: "Home Improvement",
    stat: "$247.3K",
    label: "Last 12 months · +141%",
    quote: "Six figures, fully automated.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1UVK2cF3U5GXRdTDREjw4CB_P6Y-Y_DDm=w700",
    name: "Omar",
    meta: "5 months in",
    tag: "Health & Household",
    stat: "$172.8K",
    label: "Last 30 days · +106%",
    quote: "Consistent five-figure days with third-party suppliers.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1tK3urIlajRmLxnqOGVC9iWMjuJcaZ-Fd=w700",
    name: "Priya",
    meta: "6 months in",
    tag: "Beauty",
    stat: "$158.3K",
    label: "This week · +5589%",
    quote: "A $35k Saturday. I had to screenshot it.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/11_bC-oxVVzhUEjmBXQHrz3cgKtB-7jHR=w700",
    name: "Jessica",
    meta: "12 months in",
    tag: "Kitchen & Dining",
    stat: "$159.6K",
    label: "Last 12 months",
    quote: "Nearly $20k in a single day this month.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1o1S6vMFKw4352Q91a4SGPXBE2cY3z5ky=w700",
    name: "Amara",
    meta: "6 months in",
    tag: "Office Products",
    stat: "$106.6K",
    label: "Year to date",
    quote: "Joined the 100k club with an almost $10k day.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1rsyIzdmYdPfYnKkpU-SeFze-Vikg0DSR=w700",
    name: "Derek",
    meta: "6 months in",
    tag: "Toys & Games",
    stat: "$107.7K",
    label: "Year to date",
    quote: "From zero to six figures in half a year.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1Ar0VWM1GC9IlK1V7L7U6l-bqETOexicn=w700",
    name: "Sofia",
    meta: "6 months in",
    tag: "Garden & Outdoor",
    stat: "$111.0K",
    label: "Year to date · +591%",
    quote: "The chart only goes one direction.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/10OEOoY3epH4VGrDjGkPPelr6BiXgcPuC=w700",
    name: "Chris",
    meta: "7 months in",
    tag: "Grocery",
    stat: "$111,964",
    label: "Year to date",
    quote: "2,687 units ordered and counting.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1xE9HLKY6gWxoE3QqMkUVAiTT7JNbeKaU=w700",
    name: "Marcus",
    meta: "6 months in",
    tag: "Home & Kitchen",
    stat: "$120.6K",
    label: "This week · +5121%",
    quote: "Best week the store has ever had.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1FTKxigMBTEq0cfa31WGprfr9H0MBEUt5=w700",
    name: "Marcus",
    meta: "6 months in",
    tag: "Home & Kitchen",
    stat: "$444.8K",
    label: "Year to date · +1081%",
    quote: "274 units before dinner time.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1eJgncelpLu9w_ErmBfspWaiMwbrK-Sol=w700",
    name: "Latoya",
    meta: "8 months in",
    tag: "Home & Kitchen",
    stat: "$75,005.53",
    label: "Bi-weekly payout",
    quote: "The payout notifications never get old.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1LKTzsQ79RHc5BDiTUsZJFcBVq-JQFJmg=w700",
    name: "Ryan",
    meta: "7 months in",
    tag: "Health & Household",
    stat: "$55,888.03",
    label: "Bi-weekly payout",
    quote: "Back-to-back $40k+ payouts.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1hJS68MT5KdKLK3kkeiDqIfWtZecHvhXc=w700",
    name: "Rachel",
    meta: "4 months in",
    tag: "Home Essentials",
    stat: "$58.90K",
    label: "This month · +2598%",
    quote: "Nice payout on its way.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1XKk165i9I18mUp2pVnwDp1uY6okOs9Ss=w700",
    name: "Sam",
    meta: "First month",
    tag: "Sports & Outdoors",
    stat: "$55.41K",
    label: "First month · +421%",
    quote: "$55k in the very first month on an aged account.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/10ElTkUke_A5ujf_jU3FXZNARFKSy8i8H=w700",
    name: "John",
    meta: "3 months in",
    tag: "Tools & Auto",
    stat: "$44.89K",
    label: "In March · +111%",
    quote: "A $44k March. Zero hours worked.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1kDYdP8zdUfh7AqTY2cuxIjLH52Xkrrcq=w700",
    name: "Nicole",
    meta: "6 months in",
    tag: "Beauty & Care",
    stat: "$43,969.85",
    label: "Jan – Jun",
    quote: "1,192 units shipped while I kept my day job.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1UMBq9_rpAApm-GzigCMfnuMzh2O1xkIT=w700",
    name: "Victor",
    meta: "5 months in",
    tag: "Household Goods",
    stat: "$40,867.62",
    label: "Month to date",
    quote: "2,444 units this month alone.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1G1oWq2yw5ZV8WX0EJBEtPySy6Ri9MRA3=w700",
    name: "Jordan",
    meta: "6 months in",
    tag: "Pet Supplies",
    stat: "$35,155.18",
    label: "Bi-weekly payout",
    quote: "Biggest settlement yet.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1FAcFcaPMhxKtbowWSxAbCYGNJUwdxjff=w700",
    name: "Tina",
    meta: "5 months in",
    tag: "Kitchen & Dining",
    stat: "$35.18K",
    label: "Last 12 months · +69%",
    quote: "Let's go — another record month.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1SQSB2ZfI4A_JsjKu6VFvBD0AsauThcZL=w700",
    name: "Devon",
    meta: "2 months in",
    tag: "Books & Media",
    stat: "$30.52K",
    label: "Last 30 days · +19752%",
    quote: "18–30% net margins with third-party suppliers.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1kWMDkCqL5PfE1GeWxFq4L3vldcg5VVFQ=w700",
    name: "Hannah",
    meta: "3 months in",
    tag: "Home & Kitchen",
    stat: "$30,357.77",
    label: "Scheduled payout",
    quote: "We took this store over from another automation company.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1gmzcPM0CJG_GE21M-Iqkv2l8SZkG7Qcl=w700",
    name: "Laura",
    meta: "3 months in",
    tag: "Health & Beauty",
    stat: "$30.65K",
    label: "In March · +89%",
    quote: "Over $30k in a single month.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/128BI0hljH3bn4EMbVSECaWpxUO70Mr0O=w700",
    name: "Isaiah",
    meta: "2 months in",
    tag: "Electronics",
    stat: "$26.06K",
    label: "Last 30 days · +1159%",
    quote: "New store scaling faster than expected.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/113hB3evjWRqFXsfweRVxcUzM9YPQL6lc=w700",
    name: "Monica",
    meta: "3 months in",
    tag: "Grocery",
    stat: "$23,342.86",
    label: "Apr – Jun",
    quote: "1,148 units in the first quarter.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/14pDHZiFPnDogfp8d_ofYZh6ysFaz8cnv=w700",
    name: "Carlos",
    meta: "4 months in",
    tag: "Office Products",
    stat: "$20,578.46",
    label: "Scheduled payout",
    quote: "Direct to my bank, every two weeks.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/17SrSIy1TPPkDoOiDy0pZfdcAj5CeGy5e=w700",
    name: "Grant",
    meta: "2 months in",
    tag: "Home Improvement",
    stat: "$19,182.38",
    label: "Month to date",
    quote: "1,065 units ordered this month.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1yDReYOCl2-Kgibyqz1uw3fQaVy14fpcX=w700",
    name: "Alyssa",
    meta: "6 weeks in",
    tag: "Garden & Outdoor",
    stat: "$19.24K",
    label: "Last 30 days · +34%",
    quote: "Slow and steady — 100% automated.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1OxKMBx0SvOb0v-EdCJBMlurLE00nFTDp=w700",
    name: "Brandon",
    meta: "3 months in",
    tag: "Household Goods",
    stat: "$17.91K",
    label: "In March · +108%",
    quote: "An extra $17k of income this March.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1YP0K-C6OkuaQAvRH1TcHNs7lkncetcV_=w700",
    name: "Trevor",
    meta: "3 months in",
    tag: "Sports & Outdoors",
    stat: "$16,883.79",
    label: "Apr – Jun",
    quote: "894 units without touching a thing.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1Jl6m-UiW6ZudvNDmSU4A1w0g2JrTVu9i=w700",
    name: "Dana",
    meta: "Month 2",
    tag: "Beauty & Care",
    stat: "$16.66K",
    label: "This month",
    quote: "$16k already in month two.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1ql9DzmNZhcI1rLnT59DFeoJqLia4j9bM=w700",
    name: "Nancy",
    meta: "Month 2",
    tag: "Home Essentials",
    stat: "$16.08K",
    label: "This month · +128%",
    quote: "Over $16k in my second month!",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1gh5vZJa3AAzcuhmmI2cwxl1v3FvFl2Dr=w700",
    name: "Felix",
    meta: "5 months in",
    tag: "Toys & Games",
    stat: "$13.59K",
    label: "Last 12 months",
    quote: "New month, new record.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1AMcWsktch31imdYpKcO54JRrWPZQeXsA=w700",
    name: "Emily",
    meta: "2 months in",
    tag: "Pet Supplies",
    stat: "$10,120.51",
    label: "Scheduled payout",
    quote: "First five-figure payout.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1S4Tv2ImyZw63mwGPc_Df9HJ2ak9nzxkj=w700",
    name: "Paige",
    meta: "2 months in",
    tag: "Health & Household",
    stat: "$10,124.76",
    label: "Month to date",
    quote: "Up 50% on last month already.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1vNJ50raWVNVcIBmJ9weMEOa3nEXZQ9bR=w700",
    name: "Miguel",
    meta: "2 months in",
    tag: "Kitchen & Dining",
    stat: "$8,715.32",
    label: "Month to date",
    quote: "$36 average order and climbing.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1vUduSD1HuguPUBb-kZCKS_9aLUtDR17z=w700",
    name: "Matthew",
    meta: "First month",
    tag: "Home & Kitchen",
    stat: "$6,821",
    label: "First month · +301%",
    quote: "Over $6k in my first month.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1axuDkIbYIJ2UapgfTIWbKYlJWxKzSLaC=w700",
    name: "Andre",
    meta: "6 weeks in",
    tag: "Electronics",
    stat: "$6,511.06",
    label: "Scheduled payout",
    quote: "Payouts started week three.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1wfN0eE03uiIK_PCrmSOw-zH8dwPnqHnH=w700",
    name: "Erica",
    meta: "4 months in",
    tag: "Household Goods",
    stat: "$5,822.91",
    label: "Today's sales",
    quote: "993 open orders this morning.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1hNkO2wZ3qdPRQArmlOwDXG1qTNuZYK6s=w700",
    name: "Cole",
    meta: "First week",
    tag: "Grocery",
    stat: "$5,285",
    label: "Last 7 days",
    quote: "#NEWSTORE — first week live.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/16MXj7acGkt2O9aSmqIEOzWZRaVMhRFlN=w700",
    name: "Jasmine",
    meta: "First month",
    tag: "Office Products",
    stat: "$5,278",
    label: "Last 30 days · +417%",
    quote: "Brand-new store finding its rhythm.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1RlToE49tAfjapmebFpJzIlZ__3xTWyjE=w700",
    name: "Blake",
    meta: "4 months in",
    tag: "Home Improvement",
    stat: "$4,850.42",
    label: "Today's sales",
    quote: "924 open orders before lunch.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/15cSobvOOVTZ9qrVXcdpiYyhBZE3PaV8u=w700",
    name: "Renee",
    meta: "First week",
    tag: "Beauty",
    stat: "$4,059",
    label: "First week · +104%",
    quote: "#FIRSTWEEK and already profitable.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1Tyb6mBTLOwwWkCtberEiUG5hyvKrE7E1=w700",
    name: "Owen",
    meta: "3 months in",
    tag: "Grocery",
    stat: "$2,852.40",
    label: "Today's sales",
    quote: "192 units before noon.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1DNzin7EWMJncGo0oWjU1rdZv9XwdKQ4i=w700",
    name: "Shawn",
    meta: "6 months in",
    tag: "Books & Media",
    stat: "$2,428",
    label: "Year to date",
    quote: "Small store, steady climb.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1wg4dT5Ix9YL-oqJeTn710jKF1sr4KrjW=w700",
    name: "Bianca",
    meta: "5 months in",
    tag: "Health & Household",
    stat: "$2,177.10",
    label: "Today's sales",
    quote: "$30k balance waiting on payout.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1bqvibwYaBQ34zFBR-rXEOKfVMkoxyCH-=w700",
    name: "Nadia",
    meta: "3 months in",
    tag: "Home Essentials",
    stat: "$1,781",
    label: "Last 7 days · +3956%",
    quote: "The new store is kicking in.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1NFWlm77M1NN1V_bCLFWw7AYaBSw2oOP4=w700",
    name: "Kayla",
    meta: "First month",
    tag: "Pet Supplies",
    stat: "$1,002.21",
    label: "Today's sales",
    quote: "First $1k day.",
  },
  {
    img: "https://lh3.googleusercontent.com/d/1HB-yCEgOTqXqEv9q3UFEJN5f5M_yrqHZ=w700",
    name: "Marco",
    meta: "6 months in",
    tag: "Facebook Shop",
    stat: "$63,183.30",
    label: "Jan – Jun",
    quote: "4,362 purchases through the shop.",
  },
];

export function CaseStudies() {
  return (
    <section data-testid="case-studies-section" className="border-t border-black/10">
      <div className="mx-auto max-w-[1600px] px-5 py-32 md:px-10 md:py-48">
        <Reveal>
          <Overline>Client results</Overline>
          <h2 className="mt-6 max-w-4xl font-display text-4xl font-black tracking-tighter sm:text-5xl lg:text-6xl">
            Real stores. <span className="text-signal">Real payouts.</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid gap-px bg-white/10 md:grid-cols-3">
          {CASES.slice(0, 10).map((c, i) => (
            <Reveal key={i} delay={(i % 3) * 0.12} className="bg-white">
              <article data-testid={`case-study-${i}`} className="group h-full">
                <div className="relative h-56 overflow-hidden bg-smoke">
                  <img
                    src={c.img}
                    alt={`${c.name} — ${c.tag} store dashboard`}
                    loading="lazy"
                    className="h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 bg-black/70 px-3 py-1.5 font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#FFD60A] backdrop-blur">
                    {c.tag}
                  </span>
                </div>
                <div className="p-8 md:p-10">
                  <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-ink/50">
                    {c.name} · {c.meta}
                  </p>
                  <p className="mt-4 font-display text-5xl font-black tracking-tighter text-ink md:text-6xl">
                    {c.stat}
                  </p>
                  <p className="mt-2 font-mono2 text-[11px] uppercase tracking-[0.2em] text-signal">
                    {c.label}
                  </p>
                  <p className="mt-5 font-body text-sm italic leading-relaxed text-ink/60">
                    “{c.quote}”
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-24">
          <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-signal">
            The rest of the wall
          </p>
          <h3 className="mt-4 font-display text-2xl font-bold tracking-tight md:text-3xl">
            40 more client dashboards — same program, same team.
          </h3>
        </Reveal>
        <div className="mt-10 grid gap-px bg-black/10 sm:grid-cols-2 lg:grid-cols-4">
          {CASES.slice(10).map((c, i) => (
            <Reveal key={`w-${i}`} delay={(i % 4) * 0.06} className="bg-white">
              <article data-testid={`case-compact-${i}`} className="group h-full">
                <div className="relative h-36 overflow-hidden bg-smoke">
                  <img
                    src={c.img}
                    alt={`${c.name} — ${c.tag} store dashboard`}
                    loading="lazy"
                    className="h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-ink/50">
                    {c.name} · {c.tag} · {c.meta}
                  </p>
                  <p className="mt-2 font-display text-3xl font-black tracking-tighter text-ink">
                    {c.stat}
                  </p>
                  <p className="mt-1 font-mono2 text-[10px] uppercase tracking-[0.2em] text-signal">
                    {c.label}
                  </p>
                  <p className="mt-3 font-body text-xs italic leading-relaxed text-ink/60">
                    “{c.quote}”
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-6 font-body text-xs text-ink/35">
            Every screenshot above is pulled straight from a real client
            dashboard — all 50 of them. These are real, individual results;
            they are not typical and your results will vary.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
